/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import {
    getContainerClient,
    getFilesInContainer,
    createImageInContainer,
    // createImageInContainerSAS,
    // getImageFromStorage,
} from "./azure-blob-storage";
import { Logger } from "cms/utils/log/logger";

const uploadImageAzure = async (storageAccount, containerName, file, userDelegateSasToken) => {
    if (!file) {
        return [];
    }
    let upload_status;
    try {
        Logger.debug(`uploading ${file.name} to ${storageAccount}/${containerName}/?${userDelegateSasToken}`);
        
        // Using Azure SDK
        const containerClient = await getContainerClient(
            storageAccount, containerName, userDelegateSasToken
        );
        // upload file
        await createImageInContainer(containerClient, file);
        
        // Using Axios
        // await createImageInContainerSAS(storageAccount, containerName, file, userDelegateSasToken, updateProgress)
        
        upload_status = {
            status: "UPLOADED",
            message: "The upload has completed successfully.",
        };
    } catch (err) {
        Logger.error(err);
        upload_status = {
            status: "ERROR",
            message: err.message,
        };
        //TODO: throw on error to stop further uploads
    }
    return upload_status;
};

// const getImageAzure = async (storageAccount, containerName, fileName, userDelegateSasToken) => {
//     try {
//         if (!fileName) return
//         Logger.debug(`uploading ${file.name} to ${storageAccount}/${containerName}/?${userDelegateSasToken}`)
//         const containerClient = getContainerClient(storageAccount, containerName, userDelegateSasToken)
//         return await getImageFromStorage(storageAccount, containerName, fileName, sasToken)
//         // return await getImageFromStorage(containerClient, file)
//     } catch (err) {
//         Logger.error(err)
//     }
// };

export {
    uploadImageAzure,
    getFilesInContainer,
    // getImageAzure,
};
